import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '@ridango/core';

@Component({
    selector: 'ridango-selectable-item',
    templateUrl: './selectable-item.component.html',
    styleUrls: ['./selectable-item.component.scss']
})
export class SelectableItemComponent extends BaseComponent {
    @Input() item: any;
    @Input() selected = false;
    @Input() disabled = false;
    @Input() rclass;
    @Input() last;
    @Output() onItemSelected = new EventEmitter<any>();
    @Output() onMovedLeft = new EventEmitter<any>();
    @Output() onMovedRight = new EventEmitter<any>();
    @Output() onFocused = new EventEmitter<any>();
    @Output() onBlurred = new EventEmitter<any>();

    constructor() {
        super();
    }

    selectItem() {
        if (!this.disabled) {
            this.onItemSelected.emit(this.item);
        }
    }

    movedLeft() {
        if (!this.disabled) {
            this.onMovedLeft.emit(this.item);
        }
    }

    movedRight() {
        if (!this.disabled) {
            this.onMovedRight.emit(this.item);
        }
    }

    focused() {
        if (!this.disabled) {
            this.onFocused.emit(this.item);
        }
    }

    blurred() {
        this.onBlurred.emit(this.item);
    }
}
